import { isEqual, get } from "lodash";
import Cookies from "js-cookie";

export const REQUEST_NAVBAR_STATS = "REQUEST_NAVBAR_STATS";
export const RECEIVE_NAVBAR_STATS = "RECEIVE_NAVBAR_STATS";

const requestNavbarStats = () => ({ type: REQUEST_NAVBAR_STATS });
const receiveNavbarStats = (data) => ({ type: RECEIVE_NAVBAR_STATS, data });

export const fetchNavbarStats = () => (dispatch) => {
  dispatch(requestNavbarStats());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/navbar_stats`,
    data: { brand_id: Cookies.get("bId"), user_id: Cookies.get("uId") },
    success(data) {
      dispatch(receiveNavbarStats(data));
    },
    error(xhr) {
      console.log(xhr);
      // dispatch(receiveServerErrors(xhr));
    },
  });
};
